import createIcon from '../../createIcon';

/**
 * @component @name WrongLocation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNzMwNSA5Ljc3MDQ3VjMuMDMwNDdDMTIuMDgwNSAyLjg2MDQ3IDExLjQxMDUgMi43NzA0NyAxMC43MzA1IDIuNzcwNDdDNi41MzA0NyAyLjc3MDQ3IDIuNzMwNDcgNS45OTA0NyAyLjczMDQ3IDEwLjk3MDVDMi43MzA0NyAxNC4yOTA1IDUuNDAwNDcgMTguMjIwNSAxMC43MzA1IDIyLjc3MDVDMTYuMDYwNSAxOC4yMjA1IDE4LjczMDUgMTQuMjkwNSAxOC43MzA1IDEwLjk3MDVDMTguNzMwNSAxMC41NjA1IDE4LjY5MDUgMTAuMTYwNSAxOC42NDA1IDkuNzcwNDdIMTIuNzMwNVpNMTAuNzMwNSAxMi43NzA1QzkuNjMwNDcgMTIuNzcwNSA4LjczMDQ3IDExLjg3MDUgOC43MzA0NyAxMC43NzA1QzguNzMwNDcgOS42NzA0NyA5LjYzMDQ3IDguNzcwNDcgMTAuNzMwNSA4Ljc3MDQ3QzExLjgzMDUgOC43NzA0NyAxMi43MzA1IDkuNjcwNDcgMTIuNzMwNSAxMC43NzA1QzEyLjczMDUgMTEuODcwNSAxMS44MzA1IDEyLjc3MDUgMTAuNzMwNSAxMi43NzA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIxLjI3MDUgMi42NTA0N0wxOS44NTA1IDEuMjMwNDdMMTcuNzMwNSAzLjM2MDQ3TDE1LjYxMDUgMS4yMzA0N0wxNC4xOTA1IDIuNjUwNDdMMTYuMzIwNSA0Ljc3MDQ3TDE0LjE5MDUgNi44OTA0N0wxNS42MTA1IDguMzEwNDdMMTcuNzMwNSA2LjE4MDQ3TDE5Ljg1MDUgOC4zMTA0N0wyMS4yNzA1IDYuODkwNDdMMTkuMTQwNSA0Ljc3MDQ3TDIxLjI3MDUgMi42NTA0N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WrongLocation = createIcon('WrongLocation', [
  [
    'path',
    {
      d: 'M12.7305 9.77047V3.03047C12.0805 2.86047 11.4105 2.77047 10.7305 2.77047C6.53047 2.77047 2.73047 5.99047 2.73047 10.9705C2.73047 14.2905 5.40047 18.2205 10.7305 22.7705C16.0605 18.2205 18.7305 14.2905 18.7305 10.9705C18.7305 10.5605 18.6905 10.1605 18.6405 9.77047H12.7305ZM10.7305 12.7705C9.63047 12.7705 8.73047 11.8705 8.73047 10.7705C8.73047 9.67047 9.63047 8.77047 10.7305 8.77047C11.8305 8.77047 12.7305 9.67047 12.7305 10.7705C12.7305 11.8705 11.8305 12.7705 10.7305 12.7705Z',
      key: '1tbspb',
    },
  ],
  [
    'path',
    {
      d: 'M21.2705 2.65047L19.8505 1.23047L17.7305 3.36047L15.6105 1.23047L14.1905 2.65047L16.3205 4.77047L14.1905 6.89047L15.6105 8.31047L17.7305 6.18047L19.8505 8.31047L21.2705 6.89047L19.1405 4.77047L21.2705 2.65047Z',
      key: '1f6qsm',
    },
  ],
]);

export default WrongLocation;
